import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, RadioGroup, FormControlLabel, Radio, Typography } from "@mui/material";

interface AdminModalProps {
    open: boolean;
    onClose: () => void;
    onSave: (adminData: any) => void;
    initialData?: { name: string; email: string; password?: string; isSuper: boolean; isContentAdmin: boolean };
    isEdit?: boolean;
}

export default function AddAdmin({ open, onClose, onSave, initialData, isEdit }: AdminModalProps) {
    const [adminData, setAdminData] = useState({
        name: "",
        email: "",
        password: "",
        isSuper: false,
        isContentAdmin: false
    });

    useEffect(() => {
        if (initialData) {
            setAdminData({
                ...initialData,
                password: "",
                isContentAdmin: initialData.isContentAdmin || false // Ensure isContentAdmin is set
            });
        } else {
            // Reset form when creating new admin
            setAdminData({
                name: "",
                email: "",
                password: "",
                isSuper: false,
                isContentAdmin: false
            });
        }
    }, [initialData, open]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAdminData({ ...adminData, [e.target.name]: e.target.value });
    };

    const handleRoleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const role = e.target.value;
        setAdminData({
            ...adminData,
            isSuper: role === "super",
            isContentAdmin: role === "content"
        });
    };

    const getRoleValue = () => {
        if (adminData.isSuper) return "super";
        if (adminData.isContentAdmin) return "content";
        return "admin";
    };

    const handleSave = () => {
        onSave(adminData);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{isEdit ? "Update Admin" : "Add New Admin"}</DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    label="Name"
                    name="name"
                    value={adminData.name}
                    onChange={handleChange}
                    margin="dense"
                />
                <TextField
                    fullWidth
                    label="Email"
                    name="email"
                    type="email"
                    value={adminData.email}
                    onChange={handleChange}
                    margin="dense"
                />
                {!isEdit && (
                    <TextField
                        fullWidth
                        label="Password"
                        name="password"
                        type="password"
                        value={adminData.password}
                        onChange={handleChange}
                        margin="dense"
                    />
                )}
                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                    Role:
                </Typography>
                <RadioGroup
                    row
                    name="role"
                    value={getRoleValue()}
                    onChange={handleRoleChange}
                >
                    <FormControlLabel
                        value="super"
                        control={<Radio />}
                        label="Super Admin"
                    />
                    <FormControlLabel
                        value="content"
                        control={<Radio />}
                        label="Content Admin"
                    />
                    <FormControlLabel
                        value="admin"
                        control={<Radio />}
                        label="Admin"
                    />
                </RadioGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">Cancel</Button>
                <Button onClick={handleSave} color="primary" variant="contained">
                    {isEdit ? "Update" : "Create"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}